/** Marketing landing copy — merged into LanguageContext translations. */
export const marketingTranslationsEn: Record<string, string> = {
  'marketing.nav.product': 'Product',
  'marketing.nav.pricing': 'Pricing',
  'marketing.nav.agency': 'Agencies',
  'marketing.nav.faq': 'FAQ',
  'marketing.nav.contact': 'Contact us',
  'marketing.nav.login': 'Sign in',
  'marketing.nav.trialCta': 'Start free trial',
  'marketing.nav.language': 'Language',
  'marketing.nav.menuOpen': 'Open menu',
  'marketing.nav.menuTitle': 'Menu',

  'marketing.hero.audience': 'For HR teams, hiring managers and recruitment agencies',
  'marketing.hero.tagline': 'Recruitment software · You make every hire decision',
  'marketing.hero.titleLine1': 'Publish the role.',
  'marketing.hero.titleLine2': 'Choose the right people faster.',
  'marketing.hero.valueProp':
    'One place for your job ad, branded apply page, CV summaries and interview prep. Ask the built-in assistant at any step — it knows your roles and candidates.',
  'marketing.hero.ctaTrial': 'Start free trial — 7 days',
  'marketing.hero.ctaSecondary': 'See plans and pricing',
  'marketing.hero.proof1': 'No credit card to start',
  'marketing.hero.proof2': 'Full product during the trial',
  'marketing.hero.proof3': 'Cancel anytime from your account',

  'marketing.stats.screening': 'Less time on CV admin',
  'marketing.stats.quality': 'Faster shortlists',
  'marketing.stats.trial': 'Try before you buy',
  'marketing.stats.badgeGdpr': 'GDPR aware',
  'marketing.stats.badgeAiAct': 'Built for EU AI Act',
  'marketing.stats.badgeHumanLoop': 'Human in the loop',

  'marketing.steps.title': 'How it works in practice',
  'marketing.steps.subtitle':
    'The same path you follow in the app — no parallel tools or spreadsheets.',
  'marketing.steps.step1.title': 'Publish the role',
  'marketing.steps.step1.body':
    'Write the job description (with assistant help), launch your branded apply page, and share the link on LinkedIn, your site or by email.',
  'marketing.steps.step2.title': 'Review applications',
  'marketing.steps.step2.body':
    'Each CV arrives with a plain-language summary and fit indication. You open the profiles that matter — not every attachment.',
  'marketing.steps.step3.title': 'Interview and decide',
  'marketing.steps.step3.body':
    'Use suggested questions, optional transcripts and reports, and your own stages. You move candidates forward — nothing is rejected automatically.',
  'marketing.steps.cta': 'Start with a real position — free for 7 days',

  'marketing.product.eyebrow': 'Product preview',
  'marketing.product.title': 'What you see in HiroMatch',
  'marketing.product.subtitle':
    'Positions, candidates, public apply page and interview materials — one workspace for the whole hiring team.',
  'marketing.product.cta': 'Try it on your next role',
  'marketing.product.tab.positions': 'Open roles',
  'marketing.product.tab.detail': 'Job + assistant',
  'marketing.product.tab.applications': 'Applications',
  'marketing.product.tab.report': 'Interview report',
  'marketing.product.tab.career': 'Apply page',
  'marketing.product.caption.positions': 'All active roles in one view',
  'marketing.product.caption.detail': 'Write and refine the job with AI support',
  'marketing.product.caption.applications': 'Prioritise candidates with clear summaries',
  'marketing.product.caption.report': 'Debrief with transcript and structured notes',
  'marketing.product.caption.career': 'Candidates apply on your branded page',

  'marketing.assistant.badge': 'Your recruiting assistant',
  'marketing.assistant.title': 'Answers about your hiring — not generic tips from the web',
  'marketing.assistant.lead':
    'The assistant reads your open roles and applications. Same thread from the job text to the shortlist.',
  'marketing.assistant.b1': 'Draft or improve the job ad (IT/EN, tone, requirements).',
  'marketing.assistant.b2': 'Ask why a profile fits, what to clarify, or how two candidates compare.',
  'marketing.assistant.b3': 'Prepare the hiring manager: questions, recap, internal note.',

  'marketing.core.sectionTitle': 'Everything in one hiring flow',
  'marketing.core.sectionSubtitle':
    'Each block below is a step recruiters use every week. AI speeds up reading and writing; you keep the final call.',
  'marketing.core.jd.title': 'Job description without starting from a blank page',
  'marketing.core.jd.body':
    'Turn bullet points into a structured posting. Adjust tone and requirements, then publish when the text sounds like your company.',
  'marketing.core.career.title': 'A professional apply page under your brand',
  'marketing.core.career.body':
    'Candidates apply on hiromatch.com with your logo and role title — mobile-friendly, few fields, CV upload. You receive applications in your inbox view.',
  'marketing.core.screening.title': 'Every CV summarised — not just stored',
  'marketing.core.screening.body':
    'Experience, strengths and gaps in clear language, with a fit indication. Ideal when volume is high or the hiring manager needs a quick briefing.',
  'marketing.core.questions.title': 'Interview questions ready before the call',
  'marketing.core.questions.body':
    'Suggestions based on the CV and the role. A practical starting point for phone screens and panel interviews.',
  'marketing.core.interview.title': 'After the interview: transcript and report',
  'marketing.core.interview.body':
    'On eligible plans, record the conversation and get a structured debrief. You review before sharing internally.',

  'marketing.human.badge': 'Human in the loop',
  'marketing.human.title': 'AI proposes. You approve.',
  'marketing.human.body':
    'Built for European teams who want speed without losing control of the process or the candidate experience.',
  'marketing.human.b1': 'No automatic rejections or hires — you move every stage.',
  'marketing.human.b2': 'Transparent use of AI; GDPR-oriented design.',
  'marketing.human.b3': 'Works for in-house HR and agencies with multiple clients.',

  'marketing.trust.title': 'Built for European hiring teams',
  'marketing.trust.body':
    'Data handled with GDPR in mind, clear AI boundaries, and documentation you can share with your DPO or legal team.',
  'marketing.trust.ctaFaq': 'Read frequently asked questions',

  'marketing.agency.title': 'Recruitment agency?',
  'marketing.agency.body':
    'Manage each client in a separate workspace with the same tools as corporate HR. Volume and contract tailored to your agency.',
  'marketing.agency.bullet1': 'One workspace per client brand',
  'marketing.agency.bullet2': 'Per-client limits aligned with SME plans',
  'marketing.agency.bullet3': 'Dedicated onboarding with our team',
  'marketing.agency.cta': 'Contact us',
  'marketing.agency.mailtoSubject': 'Agency plan request — hiromatch.com',
  'marketing.agency.mailtoBody':
    'Hi HiroMatch team,\n\nI would like to discuss an Agency / multi-company plan.\n\nAgency name: \nRecruiters: \nClient companies: \nEmail: \nNotes: \n\nThanks!',

  'marketing.pricing.title': 'Plans that scale with your hiring volume',
  'marketing.pricing.subtitle':
    'Start free for 7 days. After that, your account stays free in read-only mode until you subscribe. Paid plans bill monthly.',
  'marketing.pricing.reassurance':
    'Prices exclude VAT. Limits match what you see after signup — no surprise caps in the app.',
  'marketing.pricing.compareTitle': 'Compare plans, limits and AI pools',
  'marketing.limits.positions': '{n} active positions (at the same time)',
  'marketing.compare.row.positions': 'Active positions (at the same time)',
  'marketing.pricing.perMonth': '/mo',
  'marketing.pricing.trial.badge': 'Try first',
  'marketing.pricing.trial.price': 'Free · 7 days',
  'marketing.pricing.trial.includes': '25 AI-processed candidates + 25 AI Credits',
  'marketing.pricing.starter.name': 'Starter',
  'marketing.pricing.starter.price': '€99/mo',
  'marketing.pricing.starter.note': 'Small teams hiring regularly',
  'marketing.pricing.growth.name': 'Growth',
  'marketing.pricing.growth.price': '€249/mo',
  'marketing.pricing.growth.note': 'Most popular — ongoing hiring',
  'marketing.pricing.professional.name': 'Professional',
  'marketing.pricing.professional.price': '€449/mo',
  'marketing.pricing.professional.note': 'High volume and larger teams',
  'marketing.pricing.ctaTrial': 'Start free trial',
  'marketing.pricing.ctaStartTrial': 'Start free trial',
  'marketing.pricing.ctaSubscribe': 'Subscribe now',

  'marketing.compare.row.jdAi': 'Job writing assistant',
  'marketing.compare.row.brandedPage': 'Branded apply page',
  'marketing.compare.row.screening': 'CV summary and fit indication',
  'marketing.compare.row.interviewQuestions': 'Suggested interview questions',
  'marketing.compare.row.interviewReport': 'Interview report',
  'marketing.compare.humanNote':
    'Call transcription from Starter upward. Trial includes core features with lower monthly limits.',

  'marketing.final.title': 'Test HiroMatch on a live role this week',
  'marketing.final.subtitle':
    'Create one position, share the apply link, and review real applications — free for 7 days, no card required.',
  'marketing.final.ctaTrial': 'Start free trial',
  'marketing.final.login': 'I already have an account',
  'marketing.final.note': 'Questions? See FAQ or contact us — we reply within one business day.',

  'marketing.contact.badge': 'Contact',
  'marketing.contact.title': 'Contact us',
  'marketing.contact.subtitle':
    'General questions, agency plans or a product walkthrough. Send the form and we will reply by email.',
  'marketing.contact.visualIntro':
    'A glimpse of the recruiter workspace: roles, applications, apply page and interview materials.',
  'marketing.contact.visualCaption': 'Example views — your data stays private to your company',
  'marketing.contact.typeLabel': 'Topic',
  'marketing.contact.type.general': 'General question',
  'marketing.contact.type.agency': 'Agency / multi-company plan',
  'marketing.contact.type.demo': 'Product demo',
  'marketing.contact.name': 'Full name',
  'marketing.contact.email': 'Work email',
  'marketing.contact.company': 'Company (optional)',
  'marketing.contact.message': 'Message',
  'marketing.contact.submit': 'Send message',
  'marketing.contact.success': 'Message sent — we will reply soon.',
  'marketing.contact.successTitle': 'Thank you',
  'marketing.contact.successBody': 'We received your message and will get back to you shortly.',
  'marketing.contact.backHome': 'Back to home',
  'marketing.contact.errorGeneric': 'Could not send. Please try again in a moment.',
  'marketing.contact.errorUnavailable': 'Form temporarily unavailable. Please try again later.',

  'marketing.faq.title': 'Frequently asked questions',
  'marketing.footer.rights': '© HiroMatch — All rights reserved.',
  'marketing.footer.contact': 'Contact us',
  'marketing.footer.privacy': 'Privacy Policy',
  'marketing.footer.terms': 'Terms and Conditions',
  'marketing.footer.cookies': 'Cookie Policy',
  'marketing.footer.aiTransparency': 'AI Transparency',
  'marketing.footer.subprocessors': 'Sub-processors',
  'marketing.footer.cookiePreferences': 'Manage cookie preferences',
  'marketing.footer.legalGroup': 'Legal',
  'marketing.footer.goneLegal': 'HiroMatch is part of G-One Srl',
  'marketing.footer.goneAddress': 'Via Duccio di Buoninsegna 74, 00142 Roma, Italy',
  'marketing.footer.goneVat': 'P.IVA / CF: 17440701005',
};

export const marketingTranslationsIt: Record<string, string> = {
  'marketing.nav.product': 'Prodotto',
  'marketing.nav.pricing': 'Prezzi',
  'marketing.nav.agency': 'Agenzie',
  'marketing.nav.faq': 'FAQ',
  'marketing.nav.contact': 'Contattaci',
  'marketing.nav.login': 'Accedi',
  'marketing.nav.trialCta': 'Prova gratis',
  'marketing.nav.language': 'Lingua',
  'marketing.nav.menuOpen': 'Apri menu',
  'marketing.nav.menuTitle': 'Menu',

  'marketing.hero.audience': 'Per team HR, hiring manager e agenzie di recruiting',
  'marketing.hero.tagline': 'Software per la selezione · Le decisioni restano tue',
  'marketing.hero.titleLine1': 'Pubblica la posizione.',
  'marketing.hero.titleLine2': 'Scegli prima le persone giuste.',
  'marketing.hero.valueProp':
    'Un solo posto per annuncio, pagina candidature col tuo brand, riepiloghi CV e preparazione colloqui. Chiedi all\'assistente integrato in ogni fase — conosce ruoli e candidati.',
  'marketing.hero.ctaTrial': 'Prova gratis — 7 giorni',
  'marketing.hero.ctaSecondary': 'Vedi piani e prezzi',
  'marketing.hero.proof1': 'Nessuna carta per iniziare',
  'marketing.hero.proof2': 'Prodotto completo in prova',
  'marketing.hero.proof3': 'Disdici quando vuoi dall\'account',

  'marketing.stats.screening': 'Meno tempo sui CV',
  'marketing.stats.quality': 'Shortlist più rapide',
  'marketing.stats.trial': 'Prova senza rischio',
  'marketing.stats.badgeGdpr': 'GDPR aware',
  'marketing.stats.badgeAiAct': 'Progettato per EU AI Act',
  'marketing.stats.badgeHumanLoop': 'Human in the loop',

  'marketing.steps.title': 'Come funziona in pratica',
  'marketing.steps.subtitle':
    'Lo stesso percorso che segui in piattaforma — senza altri strumenti o fogli Excel.',
  'marketing.steps.step1.title': 'Pubblica la posizione',
  'marketing.steps.step1.body':
    'Scrivi l\'annuncio (con l\'aiuto dell\'assistente), attiva la pagina brandizzata e condividi il link su LinkedIn, sito o email.',
  'marketing.steps.step2.title': 'Valuta le candidature',
  'marketing.steps.step2.body':
    'Ogni CV arriva con riepilogo chiaro e indicazione di affinità. Apri i profili che contano — non ogni allegato.',
  'marketing.steps.step3.title': 'Colloquio e decisione',
  'marketing.steps.step3.body':
    'Domande suggerite, trascrizione e report se previsti dal piano, e le tue fasi. Sposti i candidati avanti — nessuno scarto automatico.',
  'marketing.steps.cta': 'Prova su una posizione vera — 7 giorni gratis',

  'marketing.product.eyebrow': 'Anteprima prodotto',
  'marketing.product.title': 'Cosa vedi in HiroMatch',
  'marketing.product.subtitle':
    'Posizioni, candidati, pagina apply pubblica e materiali colloquio — un workspace per tutto il team.',
  'marketing.product.cta': 'Provalo sulla prossima posizione',
  'marketing.product.tab.positions': 'Posizioni aperte',
  'marketing.product.tab.detail': 'Posizione + assistente',
  'marketing.product.tab.applications': 'Candidature',
  'marketing.product.tab.report': 'Report colloquio',
  'marketing.product.tab.career': 'Pagina apply',
  'marketing.product.caption.positions': 'Tutte le posizioni attive in un colpo d\'occhio',
  'marketing.product.caption.detail': 'Scrivi e rifinisci l\'annuncio con supporto AI',
  'marketing.product.caption.applications': 'Priorità ai candidati con riepiloghi chiari',
  'marketing.product.caption.report': 'Debrief con trascrizione e note strutturate',
  'marketing.product.caption.career': 'Il candidato si candida sulla tua pagina',

  'marketing.assistant.badge': 'Il tuo assistente recruiting',
  'marketing.assistant.title': 'Risposte sulla tua selezione — non consigli generici dal web',
  'marketing.assistant.lead':
    'L\'assistente legge posizioni aperte e candidature. Stesso filo dall\'annuncio alla shortlist.',
  'marketing.assistant.b1': 'Bozza o migliora l\'annuncio (IT/EN, tono, requisiti).',
  'marketing.assistant.b2': 'Chiedi perché un profilo è adatto, cosa chiarire, come confrontare due CV.',
  'marketing.assistant.b3': 'Prepara il hiring manager: domande, recap, nota interna.',

  'marketing.core.sectionTitle': 'Tutto in un unico flusso di selezione',
  'marketing.core.sectionSubtitle':
    'Ogni blocco è un passaggio che i recruiter usano ogni settimana. L\'AI accelera lettura e scrittura; la decisione finale resta tua.',
  'marketing.core.jd.title': 'Annuncio senza partire da pagina bianca',
  'marketing.core.jd.body':
    'Trasforma punti elenco in un testo strutturato. Regola tono e requisiti, poi pubblica quando suona come la tua azienda.',
  'marketing.core.career.title': 'Pagina di candidatura professionale col tuo brand',
  'marketing.core.career.body':
    'Il candidato si candida su hiromatch.com con logo e titolo ruolo — da mobile, pochi campi, upload CV. Le application arrivano nella tua lista.',
  'marketing.core.screening.title': 'Ogni CV riassunto — non solo archiviato',
  'marketing.core.screening.body':
    'Esperienza, punti di forza e gap in linguaggio chiaro, con indicazione di fit. Ideale con molte candidature o per un briefing veloce al hiring manager.',
  'marketing.core.questions.title': 'Domande colloquio pronte prima della call',
  'marketing.core.questions.body':
    'Suggerimenti basati su CV e ruolo. Punto di partenza per telefonate e colloqui in comitato.',
  'marketing.core.interview.title': 'Dopo il colloquio: trascrizione e report',
  'marketing.core.interview.body':
    'Sui piani previsti, registra la conversazione e ottieni un debrief strutturato. Tu rivedi prima di condividere internamente.',

  'marketing.human.badge': 'Human in the loop',
  'marketing.human.title': 'L\'AI propone. Tu approvi.',
  'marketing.human.body':
    'Pensato per team europei che vogliono velocità senza perdere il controllo del processo né l\'esperienza candidato.',
  'marketing.human.b1': 'Niente scarti o assunzioni automatiche — sposti tu ogni fase.',
  'marketing.human.b2': 'Uso trasparente dell\'AI; progettazione orientata al GDPR.',
  'marketing.human.b3': 'Per HR interno e agenzie con più clienti.',

  'marketing.trust.title': 'Pensato per chi seleziona in Europa',
  'marketing.trust.body':
    'Dati trattati con il GDPR in mente, confini chiari sull\'AI, documentazione da condividere con DPO o legale.',
  'marketing.trust.ctaFaq': 'Leggi le domande frequenti',

  'marketing.agency.title': 'Sei un\'agenzia di recruiting?',
  'marketing.agency.body':
    'Ogni cliente in un workspace separato, con gli stessi strumenti dell\'HR aziendale. Volumi e contratto su misura.',
  'marketing.agency.bullet1': 'Un workspace per brand cliente',
  'marketing.agency.bullet2': 'Limiti per cliente allineati ai piani PMI',
  'marketing.agency.bullet3': 'Onboarding dedicato con il nostro team',
  'marketing.agency.cta': 'Contattaci',
  'marketing.agency.mailtoSubject': 'Richiesta piano Agency — hiromatch.com',
  'marketing.agency.mailtoBody':
    'Ciao team HiroMatch,\n\nVorrei informazioni su un piano Agency / multi-azienda.\n\nNome agenzia: \nRecruiters: \nAziende clienti: \nEmail: \nNote: \n\nGrazie!',

  'marketing.pricing.title': 'Piani che crescono con il tuo volume di hiring',
  'marketing.pricing.subtitle':
    'Parti gratis 7 giorni. Poi l\'account resta gratuito in sola lettura finché non sottoscrivi. I piani a pagamento sono mensili.',
  'marketing.pricing.reassurance':
    'Prezzi IVA esclusa. I limiti sono quelli che vedi dopo la registrazione — nessun cap a sorpresa in app.',
  'marketing.pricing.compareTitle': 'Confronto piani, limiti e pool AI',
  'marketing.limits.positions': '{n} posizioni attive in contemporanea',
  'marketing.compare.row.positions': 'Posizioni attive in contemporanea',
  'marketing.pricing.perMonth': '/mese',
  'marketing.pricing.trial.badge': 'Prova subito',
  'marketing.pricing.trial.price': 'Gratis · 7 giorni',
  'marketing.pricing.trial.includes': '25 candidati elaborati con AI + 25 AI Credits',
  'marketing.pricing.starter.name': 'Starter',
  'marketing.pricing.starter.price': '€99/mese',
  'marketing.pricing.starter.note': 'Team piccoli che assumono spesso',
  'marketing.pricing.growth.name': 'Growth',
  'marketing.pricing.growth.price': '€249/mese',
  'marketing.pricing.growth.note': 'Il più scelto — hiring continuo',
  'marketing.pricing.professional.name': 'Professional',
  'marketing.pricing.professional.price': '€449/mese',
  'marketing.pricing.professional.note': 'Alto volume e team ampi',
  'marketing.pricing.ctaTrial': 'Inizia prova gratuita',
  'marketing.pricing.ctaStartTrial': 'Inizia prova gratuita',
  'marketing.pricing.ctaSubscribe': 'Sottoscrivi ora',

  'marketing.compare.row.jdAi': 'Assistente scrittura posizione',
  'marketing.compare.row.brandedPage': 'Pagina apply brandizzata',
  'marketing.compare.row.screening': 'Riepilogo CV e indicazione di fit',
  'marketing.compare.row.interviewQuestions': 'Domande colloquio suggerite',
  'marketing.compare.row.interviewReport': 'Report colloquio',
  'marketing.compare.humanNote':
    'Trascrizione call da Starter in su. Il Trial include le funzioni principali con limiti mensili più bassi.',

  'marketing.final.title': 'Prova HiroMatch su una posizione vera questa settimana',
  'marketing.final.subtitle':
    'Crea una posizione, condividi il link di candidatura e valuta candidature reali — 7 giorni gratis, senza carta.',
  'marketing.final.ctaTrial': 'Inizia prova gratuita',
  'marketing.final.login': 'Ho già un account',
  'marketing.final.note': 'Dubbi? Vai alle FAQ o contattaci — rispondiamo entro un giorno lavorativo.',

  'marketing.contact.badge': 'Contatti',
  'marketing.contact.title': 'Contattaci',
  'marketing.contact.subtitle':
    'Domande generali, piani per agenzie o una demo del prodotto. Invia il form e ti rispondiamo via email.',
  'marketing.contact.visualIntro':
    'Uno sguardo allo workspace recruiter: posizioni, candidature, pagina apply e materiali colloquio.',
  'marketing.contact.visualCaption': 'Viste di esempio — i tuoi dati restano privati per la tua azienda',
  'marketing.contact.typeLabel': 'Argomento',
  'marketing.contact.type.general': 'Domanda generale',
  'marketing.contact.type.agency': 'Piano Agency / multi-azienda',
  'marketing.contact.type.demo': 'Demo prodotto',
  'marketing.contact.name': 'Nome e cognome',
  'marketing.contact.email': 'Email lavoro',
  'marketing.contact.company': 'Azienda (opzionale)',
  'marketing.contact.message': 'Messaggio',
  'marketing.contact.submit': 'Invia messaggio',
  'marketing.contact.success': 'Messaggio inviato — ti risponderemo presto.',
  'marketing.contact.successTitle': 'Grazie',
  'marketing.contact.successBody': 'Abbiamo ricevuto il messaggio e ti risponderemo a breve.',
  'marketing.contact.backHome': 'Torna alla home',
  'marketing.contact.errorGeneric': 'Invio non riuscito. Riprova tra poco.',
  'marketing.contact.errorUnavailable': 'Form non disponibile al momento. Riprova più tardi.',

  'marketing.faq.title': 'Domande frequenti',
  'marketing.footer.rights': '© HiroMatch — Tutti i diritti riservati.',
  'marketing.footer.contact': 'Contattaci',
  'marketing.footer.privacy': 'Privacy Policy',
  'marketing.footer.terms': 'Termini e Condizioni',
  'marketing.footer.cookies': 'Cookie Policy',
  'marketing.footer.aiTransparency': 'Trasparenza IA',
  'marketing.footer.subprocessors': 'Sub-responsabili',
  'marketing.footer.cookiePreferences': 'Gestisci preferenze cookie',
  'marketing.footer.legalGroup': 'Legale',
  'marketing.footer.goneLegal': 'HiroMatch è parte di G-One Srl',
  'marketing.footer.goneAddress': 'Via Duccio di Buoninsegna 74, 00142 Roma',
  'marketing.footer.goneVat': 'P.IVA / CF: 17440701005',
};
